import { ApiGetSysDictList } from '@/api/sysDict/sysDict'

export default {
  namespaced: true,
  state: {
    dataPullCompleted: false,
    sysDictList: []
  },
  mutations: {
    SET_dataPullCompleted(state, payload) {
      state.dataPullCompleted = payload
    },
    SET_sysDictList(state, payload) {
      state.sysDictList = payload
    }
  },
  actions: {
    getSysDictList({ commit, state }) {
      if (state.dataPullCompleted) {
        return Promise.resolve()
      }

      let data = {
        pageNum: 1,
        pageSize: 10000
      }
      return ApiGetSysDictList(data).then(res => {
        let list = res?.data?.list || []
        commit('SET_dataPullCompleted', true)
        commit('SET_sysDictList', list)
        return Promise.resolve(list)
      })
    }
  },
  getters: {
    sysDictList: state => {
      if (state.dataPullCompleted) {
        return state.sysDictList
      } else {
        return []
      }
    },
    sysDictMap: state => {
      if (state.dataPullCompleted) {
        let map = {}
        state.sysDictList.forEach(row => {
          if (map[row['groupValue']]) {
            map[row['groupValue']][row['value']] = row['label']
          } else {
            map[row['groupValue']] = {
              [row['value']]: row['label']
            }
          }
        })
        return map
      } else {
        return {}
      }
    }
  }
}
